import en from '../../../config/locales/en.yml';
import zhHK from '../../../config/locales/zh-hk.yml';

export default {
  en: en.en,
  'zh-hk': zhHK['zh-hk']
};
